import styled from 'styled-components/macro';
import { colorCoreBlack900Base, colorCoreGray500 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { getTextStyles } from '@yme/utils/styles';
export const CardInfoWrapperStyled = styled.div `
  margin-top: 32px;

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: 0;
  }
`;
export const PartnerLogoWrapper = styled.div `
  margin-bottom: 32px;

  ${ADAPTIVE.minWidth.tablet} {
    margin-bottom: 0;
  }

  ${ADAPTIVE.minWidth.desktop} {
    margin-bottom: 32px;
  }
`;
export const LogoStyled = styled.span `
  display: block;

  ${ADAPTIVE.minWidth.tablet} {
    max-width: 360px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    max-width: 257px;
  }
`;
export const PriceWrapperStyled = styled(FlexWrapper) `
  margin-top: 32px;
  margin-bottom: 24px;
  padding: 16px 0;
  border-top: 1px solid ${colorCoreGray500};
  border-bottom: 1px solid ${colorCoreGray500};

  ${ADAPTIVE.minWidth.desktop} {
    margin-top: 40px;
  }
`;
export const PriceStyled = styled.p `
  margin: 0;
  color: ${colorCoreBlack900Base};

  ${getTextStyles('Play', 700, 24, 28)}
`;
